export { default as BaseModal } from "./BaseModal.vue";
